import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./CreateGroupModal.css";

const ModalComponent = ({
  show,
  handleClose,
  title,
  bodyText,
  primaryAction,
  primaryLabel,
  modelLoading,
}) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "18px" }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{bodyText}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={primaryAction}
          className="create-button"
          disabled={modelLoading} // Disable button when loading is true
        >
          {modelLoading ? "Creating..." : primaryLabel}{" "}
          {/* Optionally, show loading text */}
        </Button>
        <Button
          variant="secondary"
          onClick={handleClose}
          className="cancell-button cancell-button-container"
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalComponent;
